export default "__VITE_ASSET__c878c7c6__"